import { Trans, useLingui } from '@lingui/react/macro'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { IconDotsOutline18, IconTrashOutline18 } from 'nucleo-ui-outline-18'
import { FilesView } from '~/components/files/files-view'
import { decodeFilesSearch, type FilesViewSearch } from '~/components/files/files-view/search'
import { Button } from '~/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '~/components/ui/dropdown-menu'
import { useWorkspace } from '~/lib/workspace-context'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/files/')({
  component: WorkspaceFiles,
  validateSearch: (search: Record<string, unknown>): FilesViewSearch => decodeFilesSearch(search),
})

function WorkspaceFiles() {
  const { t } = useLingui()
  const navigate = useNavigate()
  const workspace = useWorkspace()
  const { workspaceSlug } = Route.useParams()
  return (
    <FilesView
      headerExtras={
        <DropdownMenu>
          <DropdownMenuTrigger
            render={
              <Button aria-label={t`More actions`} size="icon-sm" variant="ghost">
                <IconDotsOutline18 />
              </Button>
            }
          />
          <DropdownMenuContent align="end">
            <DropdownMenuItem
              onClick={() =>
                navigate({
                  params: { workspaceSlug },
                  to: '/$workspaceSlug/files/trash',
                })
              }
            >
              <IconTrashOutline18 />
              <Trans>Trash</Trans>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      }
      headerTitle={t`Files`}
      scope={{ kind: 'workspace', workspaceId: workspace._id }}
    />
  )
}
